import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state: any) => state.termsAndPolicyState || initialState;

export const TermsAndPolicyTextSelector = createSelector(
  selectDomain,
  (state) => state.termsAndPolicyText
);
